import classNames from 'classnames';
import * as React from 'react';

interface AccordionItemHeaderProps {
    readonly label: string | React.ReactElement;
    readonly handleOpenItem: (i: number, e: HTMLButtonElement | null) => void;
    readonly index: number;
    readonly isActive: boolean;
    readonly isFocused: boolean;
    readonly isExpanded: boolean;
    readonly onKeyDown: (e: React.KeyboardEvent) => void;
    readonly labelClassName?: string;
    readonly activeLabelClassName?: string;
    readonly expandedIcon?: React.ReactNode;
    readonly collapsedIcon?: React.ReactNode;
}

export const AccordionItemHeader = ({
    label,
    handleOpenItem,
    index,
    isActive,
    isExpanded,
    onKeyDown,
    isFocused,
    activeLabelClassName,
    labelClassName,
    expandedIcon,
    collapsedIcon
}: AccordionItemHeaderProps) => {
    const ref = React.useRef<HTMLButtonElement>(null);
    const [isItemActive, setIsItemActive] = React.useState<boolean>();

    React.useEffect(() => {
        if (ref.current && isFocused) {
            ref.current.focus();
        }
    }, [isExpanded, isFocused]);

    React.useEffect(() => {
        setIsItemActive(isActive);
    }, [isActive]);

    return (
        <button
            onKeyDown={onKeyDown}
            ref={ref}
            className={classNames(labelClassName, isActive && activeLabelClassName)}
            onClick={() => handleOpenItem(index, ref.current)}
            aria-expanded={isItemActive}
        >
            {label}
            {isActive ? expandedIcon : collapsedIcon}
        </button>
    );
};
